import React, { FC, useEffect, useState } from 'react';
import Popover from '@mui/material/Popover';
import { IconButton, Badge } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import './fullScreenPopup.scss';
import NotificationTable from '../notificationTable';

interface NotificationPopupType {
  notificationContent: any
}

const NotificationPopOver: FC<NotificationPopupType> = ({ notificationContent }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [newNotificationCount, setNotificationContent] = useState<number>(0)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'notification-popover' : undefined;

  useEffect(() => {
    if (notificationContent.length) {
      setNotificationContent(notificationContent.filter((content: any) => content.readIAN === false)?.length)
    }
  }, [notificationContent])


  return (
    <div className='center-div'>
      <IconButton onClick={handleClick} className='notification-icon'>
        <Badge badgeContent={newNotificationCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        sx={{ boxShadow: 3, borderRadius: 2, minWidth: 350 }}
      >
        <NotificationTable notificationContent={notificationContent} handleClose={handleClose} />
      </Popover>
    </div>
  );
}

export default NotificationPopOver